import { FiMenu } from 'react-icons/fi';
import { IoIosArrowDown } from 'react-icons/io';
import styled from 'styled-components';

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: ${({ theme }) => theme.colors.yellow};

  max-height: 8.6rem;
  height: 100%;
  width: 100%;

  padding: 0 1rem;

  z-index: 2;
  position: sticky;
  top: 0;

  @media (min-width: 768px) {
    padding: 0 5.6rem 0 3rem;
  }
`;

export const IconMenu = styled(FiMenu)`
  display: none;
  cursor: pointer;
  margin-right: 2rem;

  @media (min-width: 768px) {
    display: flex;
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.6rem;
  text-transform: uppercase;

  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
  /* width: 3rem; */

  @media screen and (min-width: 768px) {
    font-size: 3rem;
  }
`;

export const UserProfileImage = styled.img`
  display: none;

  width: 4.5rem;
  height: 4.5rem;
  border-radius: 4px;

  @media (min-width: 475px) {
    display: flex;
  }
`;

export const Username = styled.h1`
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.black};
  margin-left: 2rem;

  @media screen and (min-width: 475px) {
    font-size: 2rem;
  }
`;

export const Perfil = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  height: 100%;
  cursor: pointer;

  :hover {
    div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const IconArrowDown = styled(IoIosArrowDown)`
  margin-left: 1.6rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
